<template>
    <v-container class="mt-12 pt-8" style="background:#fafafa;">
        <v-row style="background:#fafafa;">
            <v-col cols="12" class="pa-0">
                <v-row class="py-1 px-5">
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12">
                                <v-card :loading="loading">
                                    <v-card-text class="py-0">
                                        <v-row class="align-center">
                                            <v-col cols="12" class="py-0">
                                                <v-card-text>
                                                    <div>
                                                        <v-btn 
                                            color="success" 
                                            :class="`${arabic ? 'arFont' : 'enFont'}`"
                                            style="width: 300px;" 
                                            @click="goToCreate">
                                            {{ arabic ? 'انشاء خطة' : 'Create Plan' }}
                                        </v-btn>
                                                    </div>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-simple-table>
                                                                <thead>
                                                                    <tr>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">ID</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['title'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['title_ar'] }}</th>

                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['price_id'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['price'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['compare_price'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['description'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['description_ar'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['form_submission'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['form_views'] }}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['form_count'] }}</th>

                                                                        <th class="">Activeation</th>
                                                                        <th class="">popularation</th>
                                                                        <th class="">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="item in data" :key="item.id">
                                                                        <td>{{ item.id }}</td>
                                                                        <td>{{ item.title }}</td>
                                                                        <td>{{ item.title_ar }}</td>

                                                                        <td>{{ item.price_id }}</td>
                                                                        <td>{{ item.price }}</td>
                                                                        <td>{{ item.compare_price }}</td>
                                                                        <td>{{ item.description }}</td>
                                                                        <td>{{ item.description_ar }}</td>
                                                                        <td>{{ item.form_submissions }}</td>
                                                                        <td>{{ item.form_views }}</td>
                                                                        <td>{{ item.form_number }}</td>

                                                                        <td>
                                                                            <v-switch :input-value="item.is_active"
                                                                                @change="toggleActive(item.id, $event)"
                                                                                :class="[{ 'arFont': arabic, 'enFont': !arabic }, 'mr-0']"
                                                                                label="Active" color="success" dense
                                                                                inset>
                                                                            </v-switch>
                                                                        </td>
                                                                        <td>
                                                                            <v-switch :input-value="item.is_popular"
                                                                                @change="togglePopular(item.id, $event)"
                                                                                :class="[{ 'arFont': arabic, 'enFont': !arabic }, 'mr-0']"
                                                                                label="Popular" color="success" dense
                                                                                inset>
                                                                            </v-switch>
                                                                        </td>
                                                                        <td>
                                                                            <v-btn color="primary" x-small icon
                                                                                @click="editForm(item.id)" class="ml-2">
                                                                                <v-icon size="25">edit</v-icon>
                                                                            </v-btn>
                                                                        </td>


                                                                    </tr>
                                                                </tbody>
                                                            </v-simple-table>
                                                            <v-pagination v-model="currentPage" :length="totalPages"
                                                                @input="fetchPlans"></v-pagination>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
//import axios from 'axios';
// import ListFilter from '@/components/FormBuilder/ListFilterPixel.vue';
export default {
    components: {
        // ListFilter
    },

    data() {
        return {
            data: [],
            loading: false,
            currentPage: 1,
            totalPages: 0,
        };
    },
    methods: {
    goToCreate()
    {
        this.$router.push({ name: 'add_plan' });
   
    },
        async fetchPlans() {
  // Prepare the payload for the getResource action
  const payload = {
    resource: '/data/plans',
    params: {
      page: this.currentPage
    }
  };

  try {
    this.loading = true;
    // Dispatch the getResource action with the payload
    const response = await this.$store.dispatch('getResource', payload);
    this.data = response.data.data;
    this.totalPages = response.data.last_page;
  } catch (error) {
    console.error("Failed to fetch plans:", error);
  } finally {
    this.loading = false;
  }
},

        editForm(id) {
            this.$router.push(`/Subscription/Plan/Edit/${id}`);
        },

        async toggleActive(planId, isActive) {
  // Prepare the payload for the postResource action
  const payload = {
    resource: `/plans/${planId}/toggle-active`,
    value: { is_active: isActive }
  };

  try {
    await this.$store.dispatch('postResource', payload);
    this.fetchPlans();
  } catch (error) {
    console.error("Failed to toggle active status:", error);
  }
},

async togglePopular(planId, isPopular) {
  const payload = {
    resource: `/plans/${planId}/toggle-popular`,
    value: { is_popular: isPopular }
  };

  try {
    await this.$store.dispatch('postResource', payload);
    this.fetchPlans();
  } catch (error) {
    console.error("Failed to toggle popular status:", error);
  }
},




    },
    watch: {


    },
    computed: {

        language() {
            return this.$store.state.language;
        },
        i18n() {
            return this.$store.state.i18n[this.language];
        },
        arabic() {
            return this.language === "ar";
        },
    },
    mounted() {
        this.fetchPlans();
    }
}
</script>